<div class="title-block mb-3">
  <h4 class="card-title">{{ 'TR_USERTYPES' | translate }}</h4>
</div>

<div class="row">
  <div class="col-md-8 sol-sm-12 col-12">
    <div class="flex flex-wrap">
      <div class="flex-1">
        <button *ngIf="usertype_create" class="mb-2 mr-2 btn btn-success create-btn" [title]="'TR_CREATEUSERTYPE' | translate" [routerLink]="['usertype-form']">
          <i class="fa fa-plus"></i><span class="ml-2">{{ 'TR_CREATE' | translate }}</span>
        </button>
      </div>
    
      <div *ngIf="organization_view" ngbDropdown>
        <button type="button" ngbDropdownToggle class="mb-2 btn btn-primary">
          {{ selectedOrganizationName ? selectedOrganizationName : 'TR_ORGANIZATIONS' | translate }}
        </button>
        <div ngbDropdownMenu>
          <button class="dropdown-item" (click)="getAllUsertypes(false)">{{ 'TR_ALL' | translate }}</button>
          <button class="dropdown-item" *ngFor="let item of organizations" (click)="getOrganizationUserTypes(item)">{{ item.name }}</button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="row">
  <div class="col-md-8 sol-sm-12 col-12">
    <div class="main-card mb-3 card">
      <div class="table-responsive">
        <table class="align-middle mb-0 table table-striped table-hover">
          <thead>
            <tr>
              <th>{{ 'TR_USERTYPE' | translate }}</th>
              <th *ngIf="organization_view">{{ 'TR_ORGANIZATION' | translate }}</th>
              <th class="text-center">{{ 'TR_ISDEFAULT' | translate }}</th>
              <th *ngIf="usertype_update || usertype_delete" class="text-right">{{ 'TR_ACTIONS' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr class="pointer" [class.selected]="selectedUserTypeId === item.id" *ngFor="let item of userTypes" (click)="pagesView($event.target, item)">
              <td>{{  item.displayName || item.name }}</td>
              <td *ngIf="organization_view">{{ item.organizationName }}</td>
              <td class="text-center">
                <input disabled [name]="item.name || item.displayName" type="checkbox" class="mt-2 pointer" [(ngModel)]="item.isDefault" />
              </td>
              <td class="text-right">
                <div role="group" class="btn-group-sm btn-group">
                  <button
                    *ngIf="usertype_update"
                    class="btn-transition btn btn-outline-info"
                    [title]="'TR_EDITUSERTYPE' | translate"
                    [routerLink]="['usertype-form', item.id]"
                  >
                    <i class="pe-7s-note"></i>
                  </button>
                  <button
                    *ngIf="usertype_delete"
                    type="button"
                    class="btn btn-outline-danger ml-1"
                    [title]="'TR_DELETE' | translate"
                    (click)="confirmDelete(deleteblock, item.id, item.name)">
                    <i class="pe-7s-trash"></i>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div class="col-md-4 col-sm-12 col-12">
    <ng-container *ngIf="page_view && pages && pages.length">
      <div class="main-card mb-3 card">
        <div class="table-responsive">
          <table class="align-middle mb-0 table table-hover">
            <thead>
              <tr>
                <th>{{ 'TR_PAGES' | translate }}</th>
              </tr>
            </thead>
            <tbody>
              <tr class="pointer" *ngFor="let page of pages" (click)="rolesView(rolesview, $event.target, page)">
                <td>
                  {{ page.name }}
                  <div *ngIf="page.children && page.children.length" class="main-card mb-2 mt-2 card border-none">
                    <div class="table-responsive child-table">
                      <table class="align-middle mb-0 table table-hover">
                        <tbody>
                          <tr class="pointer" *ngFor="let item of page.children" (click)="rolesView(rolesview, $event.target, item)" >
                            <td>{{ item.name }}</td>
                            <td class="text-center">
                              <input
                                [id]="item.name"
                                [name]="item.name"
                                type="checkbox"
                                class="mt-2 pointer"
                                [disabled]="isDisablePage"
                                [(ngModel)]="item.isBelongToCurrentUserType"
                                (ngModelChange)="changePageValue(item.isBelongToCurrentUserType, item.id)"
                              />
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </td>
                <td class="text-center">
                  <input
                    [id]="page.name"
                    [name]="page.name"
                    type="checkbox"
                    class="mt-2 pointer"
                    [disabled]="isDisablePage"
                    [(ngModel)]="page.isBelongToCurrentUserType"
                    (ngModelChange)="changePageValue(page.isBelongToCurrentUserType, page.id)"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </ng-container>
  </div>
</div>

<ng-template #rolesview let-c="close" let-d="dismiss">
  <app-roles
    [pageId]="selectedPageId"
    [userTypeId]="userTypeId"
    [isDefaultUserTypeSelected]="isDefaultUserTypeSelected"
    (closeEmit)="c('Close click')"
  ></app-roles>
</ng-template>

<ng-template #deleteblock let-c="close" let-d="dismiss">
  <div class="custom-modal modal-body">
    <p>{{ 'TR_DELETE_ERROR' | translate }} {{ deleteUserTypeName }}? </p>
  </div>
  <div class="custom-modal modal-footer">
    <app-action-button
      [isCurrent]="true"
      [spinnerId]="userTypeDeleteSpinnerId"
      buttonClasses="btn-transition btn btn-outline-primary"
      spinnerClasses="small-button-spinner"
      [buttonName]="'TR_YES'"
      (clicked)="delete()"
    ></app-action-button>
    <button type="button" class="btn-transition btn btn-danger" (click)="c('Close click')">{{ 'TR_NO' | translate }}</button>
  </div>
</ng-template>